import { paymentServiceVersion } from '../configuration';

export const edenredGetBalancePath = `${paymentServiceVersion}/edenred/customers/balance`;
export const edenredAuthenticationUrlPath = `${paymentServiceVersion}/edenred/customers/authentication-url`;
export const edenredLogoutPath = `${paymentServiceVersion}/edenred/customers/logout`;
